<template>
    <v-container transparent>
        <v-layout>
            <v-card width="100%" flat>
                <v-card-title class="pa-4 title">Учетная запись</v-card-title>
                <v-form v-model="profileFormValid" ref="profile_form">
                    <v-container grid-list-sm class="pa-5">
                        <v-layout row wrap>
                            <v-flex lg4 md6 xs12 align-center justify-center>
                                <v-layout column>
                                    <v-flex align-self-center align-center>
                                        <image-input v-model="profileData.avatar">
                                            <div slot="activator">
                                                <v-avatar size="150px" v-ripple v-if="!profileData.avatar.imageURL">
                                                    <img :src="profileData.ava || `/media/grey_silhouette.png`" alt="">
                                                </v-avatar>
                                                <v-avatar size="150px" v-ripple v-else>
                                                    <img :src="profileData.avatar.imageURL" alt="avatar">
                                                </v-avatar>
                                            </div>
                                        </image-input>
                                    </v-flex>
                                    <v-flex align-self-center mt-3 mb-3 tag="h3">{{profileData.name}}</v-flex>
                                </v-layout>
                            </v-flex>

                            <v-flex lg8 md6 xs12 align-center justify-space-between>
                                <v-card-title class="pa-4 title">Основные данные</v-card-title>
                                <v-layout>
                                    <v-flex xs12 md12 style="text-align: center">
                                        Все поля в данной форме обязательны для заполнения
                                    </v-flex>
                                </v-layout>
                                <v-flex v-if="true">

                                    <v-text-field prepend-icon="email" class="notranslate v-text-field-email" name="email" disabled
                                                  label="Email"
                                                  type="email" v-model="profileData.email"></v-text-field>
                                    <v-layout wrap align-content-space-around fill-height
                                              v-if="!profileData.checks.email&&false">
                                        <v-flex xs12 sm6 red--text align-self-center style="text-align: center">Ваш
                                            email не
                                            подтвержден
                                        </v-flex>
                                        <v-flex xs12 sm6 style="text-align: center">
                                            <v-btn>Подтвердить</v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-text-field prepend-icon="person" class="notranslate" name="name" label="Ваше имя" type="text"
                                                  v-model="profileData.name"
                                                  :rules="[rules.required]"></v-text-field>
                                    <v-text-field name="tel" label="Телефон" type="tel" prepend-icon="phone" class="notranslate"
                                                  placeholder="+(000) 000-00-00" mask="+#(###) ###-##-##"
                                                  v-model="profileData.tel"></v-text-field>
                                    <template>
                                        <v-menu
                                                ref="menu"
                                                v-model="utility.birthday"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                lazy
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                min-width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                        v-model="profileData.birthday"
                                                        label="День рождения"
                                                        prepend-icon="event"
                                                        class="notranslate"
                                                        readonly
                                                        v-on="on"
                                                        :rules="[rules.required]"
                                                        required
                                                        @blur="$refs.profile_form.validate()"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                    ref="picker"
                                                    v-model="profileData.birthday"
                                                    :max="new Date().toISOString().substr(0, 10)"
                                                    min="1950-01-01"
                                                    @input="utility.birthday = false"
                                            ></v-date-picker>
                                        </v-menu>
                                    </template>


                                    <v-autocomplete name="country" label="Страна"
                                                    :loading="utility.countryListLoading"
                                                    :items="utility.countryList"
                                                    item-text="name"
                                                    return-object
                                                    :search-input.sync="searchCountry"
                                                    flat
                                                    hide-no-data
                                                    browser-autocomplete="true"
                                                    prepend-icon="location_on"
                                                    class="notranslate"
                                                    :rules="[rules.required]" required
                                                    v-model="profileData.country"></v-autocomplete>

                                    <v-autocomplete name="city" label="Город"
                                                    :loading="utility.cityListLoading"
                                                    :items="utility.cityList"
                                                    item-text="alternateName"
                                                    return-object
                                                    :search-input.sync="searchCity"
                                                    flat
                                                    cache-items
                                                    hide-no-data
                                                    browser-autocomplete="true"
                                                    prepend-icon="location_city"
                                                    class="notranslate"
                                                    :disabled="!profileData.country"
                                                    :rules="[rules.required]" required
                                                    v-model="profileData.city"></v-autocomplete>


                                </v-flex>

                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
                <v-card-actions class="px-5">

                    <v-spacer></v-spacer>
                    <v-btn large color="primary" :disabled="!profileFormCanSave" @click="updateProfile()">Сохранить
                    </v-btn>
                </v-card-actions>


                <v-form v-model="passwordFormValid" ref="password_form">
                    <v-container class="pa-5">
                        <v-flex offset-lg4 offset-md6 lg8 md6 xs12 align-center justify-space-between>
                            <v-card-title primary-title class="py-4 title">
                                Сменить пароль&nbsp;
                                <v-btn small v-if="false" @click="utility.showPasswd = !utility.showPasswd">
                                    <v-icon class="notranslate">more_horiz</v-icon>
                                </v-btn>
                            </v-card-title>
                            <template v-if="utility.showPasswd">
                                <v-text-field id="current_password" prepend-icon="lock" class="notranslate" name="current_password"
                                              label="Текущий пароль" v-model="passwordData.currentPassword"
                                              :rules="[rules.required, rules.minpasswd]"
                                              :append-icon="utility.show1 ? 'visibility' : 'visibility_off'"

                                              @click:append="utility.show1 = !utility.show1"
                                              :type="utility.show1 ? 'text' : 'password'"
                                              required></v-text-field>
                                <v-text-field id="new_password" prepend-icon="lock" name="new_password" class="notranslate"
                                              label="Новый пароль" v-model="passwordData.newPassword"
                                              :rules="[rules.required, rules.minpasswd]"
                                              :append-icon="utility.show2 ? 'visibility' : 'visibility_off'"
                                              @click:append="utility.show2 = !utility.show2"
                                              :type="utility.show2 ? 'text' : 'password'"
                                              required></v-text-field>
                                <v-text-field id="new_password_confirm" prepend-icon="lock" class="notranslate"
                                              name="new_password_confirm"
                                              label="Повторите новый пароль"
                                              v-model="passwordData.newPasswordConfirm"
                                              :rules="[rules.required, rules.minpasswd]"
                                              :append-icon="utility.show3 ? 'visibility' : 'visibility_off'"
                                              @click:append="utility.show3 = !utility.show3"
                                              :type="utility.show3 ? 'text' : 'password'"
                                              :hint="newPasswordsMatch ? '' : 'Пароли не совпадают'"
                                              :error="!newPasswordsMatch"

                                              required></v-text-field>
                            </template>
                        </v-flex>
                    </v-container>
                </v-form>
                <template v-if="utility.showPasswd">
                    <v-card-actions class="px-5 pb-5">
                        <v-spacer></v-spacer>
                        <v-btn large color="primary" :disabled="!passwordFormCanSave" @click="changePassword">Сменить
                            пароль
                        </v-btn>
                    </v-card-actions>
                </template>


            </v-card>
        </v-layout>
        <v-snackbar v-model="utility.snackbar" color="error">{{ utility.snackbarText }}
            <v-btn dark flat @click="utility.snackbar = false">Close</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    //import deepEqual from 'deep-equal'
    //import assert from 'assert'
    import ImageInput from "./ImageInput";

    function jsonEqual(a, b) {
        return JSON.stringify(a) === JSON.stringify(b);
    }

    export default {
        name: "UserProfile",
        components: {ImageInput},
        props: ['action'],
        data: () => ({
            profileFormValid: false,
            profileFormIsDirty: false,
            passwordFormValid: false,
            passwordFormIsDirty: false,

            profileDataInitial: {
                name: '',
                email: '',
                emailConfirmed: false,
                tel: '',
                avatar: {imageURL: ''},
                avatarOld: {imageURL: ''},
                birthday: null,
                country: "",
                city: "",
                checks: {
                    passed: false,
                    profile: false,
                    basicAgenda: false,
                    email: false,
                    emailProccessing: false
                }

            },
            profileData: {
                name: '',
                email: '',
                emailConfirmed: false,
                tel: '',
                avatar: {imageURL: ''},
                avatarOld: {imageURL: ''},
                birthday: null,
                country: "",
                city: "",
                checks: {
                    passed: false,
                    profile: false,
                    basicAgenda: false,
                    email: false,
                    emailProccessing: false
                }
            },
            passwordData: {
                currentPassword: '',
                newPassword: '',
                newPasswordConfirm: '',
            },
            passwordDataInitial: {
                currentPassword: '',
                newPassword: '',
                newPasswordConfirm: '',
            },
            utility: {
                snackbarText: '',
                snackbar: false,
                saving: false,
                saved: false,
                showPasswd: true,
                show1: false,
                show2: false,
                show3: false,
                birthday: false,

                countryList: [],
                countryListLoading: false,
                cityList: [],
                cityListLoading: false,
            },

            searchCountry: "",
            searchCity: "",

            rules: {
                required: value => !!value || 'Required.',
                counter: value => value.length <= 20 || 'Max 20 characters',
                minpasswd: value => (value && value.length >= 6) || 'Минимум 6 символов',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Invalid e-mail.'
                }
            }
        }),
        watch: {
            'profileData.avatar': {
                handler: function () {
                    this.utility.saved = false
                    this.utility.avatarDirty = true
                },
                deep: true
            },
            profileData: {
                handler: function () {
                    // eslint-disable-next-line
                    console.log("!!!profileFormIsDirty - ", this.profileFormIsDirty)
                    //this.profileFormIsDirty  = !jsonEqual(this.profileData, this.profileDataInitial)
                }
            },
            'utility.birthday': {
                handler: function (val) {
                    val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
                }
            },
            searchCountry: function (val) {
                var this_ = this
                if (!val) {
                    this_.utility.countryList = []
                    return
                }
                if (val.length < 3) return
                this.utility.countryListLoading = true

                this.$http.post('/geonames', {endpoint: 'countryInfo', q: val})
                    .then(function (response) {
                        if (response.status == 200) {
                            this_.utility.countryList = response.data.countryInfo
                            this_.utility.countryListLoading = false
                        }
                    })
            },
            searchCity: function (val) {
                var this_ = this
                if (!val) {
                    this_.utility.cityList = []
                    return
                }
                if (val.length < 3) return
                this.utility.cityListLoading = true

                this.$http.post('/geonames', {
                    endpoint: 'alternates',
                    q: val,
                    country_code: this.profileData.country['iso_alpha2']
                })
                    .then(function (response) {
                        if (response.status === 200) {
                            this_.utility.cityList = response.data.alternates
                            this_.utility.cityListLoading = false
                        }
                    })
            },

        },
        methods: {
            uploadImage() {
                this.utility.saving = true
                setTimeout(() => this.savedAvatar(), 1000)
            },
            savedAvatar() {
                this.utility.saving = false
                this.utility.saved = true
                this.utility.avatarDirty = false
                this.profileData.avatarOld = {imageURL: this.profileData.avatar.imageURL}
            },
            updateProfile: function () {
                var this_ = this;

                if(this.profileData.avatar.imageURL){
                    if(this.profileData.avatar.imageURL!==this.profileDataInitial.avatar.imageURL){
                        const reader = new FileReader();
                        reader.onload = function(evt) {
                            this_.profileData.avatar.fileData = evt.target.result;

                            this_.$store.dispatch('updateProfile', {user: this_.profileData}).then(function (response) {
                                this_.response = response
                                if (response.status !== 200) this_.$store.dispatch('processError', this_.response)
                                if (this_.response.status === 200) {
                                    this_.$store.dispatch('processError', {status: 200, errorMessage: "Данные успешно сохранены"})
                                    this_.initForm()
                                }
                            })
                        };
                        //reader.readAsBinaryString(this.profileData.avatar.imageFile);
                        reader.readAsDataURL(this.profileData.avatar.imageFile);
                        return
                    }
                }

                this.$store.dispatch('updateProfile', {user: this.profileData}).then(function (response) {
                    this_.response = response
                    if (response.status !== 200) this_.$store.dispatch('processError', this_.response)
                    if (this_.response.status === 200) {
                        this_.$store.dispatch('processError', {status: 200, errorMessage: "Данные успешно сохранены"})
                        this_.initForm()
                        if(!this_.$store.state.user.checks.agenda) this_.$router.push('/home/agenda')
                        else if(!this_.$store.state.user.testcodes.length) this_.$router.push('/home/tests/reg')
                        else this_.$router.push('/')

                    }
                })
            },
            changePassword: function () {
                var this_ = this;
                // eslint-disable-next-line
                console.log("PASsWORDD")

                this.$store.dispatch('changePassword', {
                    password: this.passwordData.currentPassword,
                    newPassword: this.passwordData.newPassword
                }).then(function (response) {
                    this_.response = response
                    if (response.status !== 200) this_.$store.dispatch('processError', this_.response)
                    if (this_.response.status === 200) {
                        this_.$store.dispatch('processError', {status: 200, errorMessage: "Данные успешно сохранены"})
                        this_.initPasswordForm()
                    }
                })
            },
            initPasswordForm: function () {
                this.passwordData = {
                    currentPassword: '',
                    newPassword: '',
                    newPasswordConfirm: '',
                }
                this.passwordDataInitial = {
                    currentPassword: '',
                    newPassword: '',
                    newPasswordConfirm: '',
                }
                this.$refs.password_form.resetValidation()
            },
            initForm: function () {
                if (this.$store.state.user) {
//                    this.profileData = JSON.parse(JSON.stringify(this.$store.state.user))
//                    this.profileDataInitial = JSON.parse(JSON.stringify(this.$store.state.user))
                    Object.assign(this.profileData, JSON.parse(JSON.stringify(this.$store.state.user)))
                    Object.assign(this.profileDataInitial, JSON.parse(JSON.stringify(this.$store.state.user)))
                    delete this.profileData.agenda
                    delete this.profileData.reports
                    delete this.profileData.testcodeIds
                    delete this.profileData.testcodes
                    delete this.profileDataInitial.agenda
                    delete this.profileDataInitial.reports
                    delete this.profileDataInitial.testcodeIds
                    delete this.profileDataInitial.testcodes

                    if (this.profileData.city) this.utility.cityList = [this.profileData.city]
                    if (this.profileData.country) this.utility.countryList = [this.profileData.country]


                    // eslint-disable-next-line
                    console.log(this.profileData)
                }
            }
        },
        computed: {
            isProfileFormIsDirty: function () {
                // eslint-disable-next-line
                console.log("!!!isProfileFormIsDirty - ", this.profileFormIsDirty, this.profileData, this.profileDataInitial)
                return !jsonEqual(this.profileData, this.profileDataInitial)
            },
            isPasswordFormIsDirty: function () {
                return !jsonEqual(this.passwordData, this.passwordDataInitial)
            },
            profileFormCanSave: function () {
                if (this.profileFormValid && this.isProfileFormIsDirty) return true;
                return false;
            },
            passwordFormCanSave: function () {
                // eslint-disable-next-line
                console.log(this.passwordFormValid, this.isPasswordFormIsDirty)

                if (this.passwordFormValid && this.isPasswordFormIsDirty && this.newPasswordsMatch) return true;
                return false;
            },
            avatarDirty: function () {
                if (!this.profileData.avatar) return false
                if (this.profileData.avatar && !this.profileData.avatarOld) return true
                return this.profileData.avatar.imageURL !== this.profileData.avatarOld.imageURL
            },
            newPasswordsMatch: function () {
                return this.passwordData.newPassword === this.passwordData.newPasswordConfirm;
            },
            newPasswordsDontMatch: function () {
                return this.passwordData.newPassword !== this.passwordData.newPasswordConfirm;
            }
        },
        created: function () {
            //this.profileData = this.$store.state.user
            //this.profileDataInitial = this.$store.state.user
            this.initForm()
        }

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
</style>